import React from 'react'
import { useTranslation } from 'react-i18next'
import { LockKeyhole } from 'lucide-react'
import { tr } from 'i18n'
import './DriverBlockReason.scss'

export default function DriverBlockReason({ reason }: { reason?: string }) {
  useTranslation()
  return <aside className="driver-block-reason" aria-label={tr('Причина блокировки')}>
    <strong><LockKeyhole size={20} aria-hidden="true" />{tr('Причина блокировки')}</strong>
    <p>{reason?.trim() ? tr(reason) : tr('Узнайте у администрации Центрального Аппарата')}</p>
  </aside>
}
